/* eslint jsx-a11y/anchor-is-valid: 0 */
import React from 'react';

const OrganizationsList = props => {
    const orgs = props.organizations;
    let selectedId = -1;
    if (props.selected) {
        selectedId = props.selected.id;
    }

    return (
        <div className="ManagePage__list">
            {orgs &&
                orgs.map(org => {
                    let className = 'ManagePage__item';
                    if (org.id === selectedId) {
                        className = 'ManagePage__item-selected';
                    }
                    return (
                        <a
                            className={className}
                            onClick={() => {
                                props.onSelection(org);
                            }}
                            key={`org-${org.id}`}>
                            {org.name}
                        </a>
                    );
                })}
        </div>
    );
};

export default OrganizationsList;
